import { render, staticRenderFns } from "./orderMenu.vue?vue&type=template&id=08a22439&scoped=true&"
import script from "./orderMenu.vue?vue&type=script&lang=js&"
export * from "./orderMenu.vue?vue&type=script&lang=js&"
import style0 from "./orderMenu.vue?vue&type=style&index=0&id=08a22439&lang=scss&scoped=true&"
import style1 from "./orderMenu.vue?vue&type=style&index=1&id=08a22439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a22439",
  null
  
)

export default component.exports